__turbopack_context__.v({
  "className": "avertasemibold_60ca95b4-module__1DNfkq__className",
  "variable": "avertasemibold_60ca95b4-module__1DNfkq__variable",
});
